import React from 'react';
import { useReveal } from '../lib/useReveal';
import { ShieldCheckIcon } from '../lib/icons';
const DELIVERY = [{
  emoji: '📥',
  label: 'Acceso inmediato'
}, {
  emoji: '📱',
  label: 'Desde celular o PC'
}, {
  emoji: '📚',
  label: 'Formato PDF'
}, {
  emoji: '⏳',
  label: 'A tu ritmo'
}, {
  emoji: '🔓',
  label: 'Acceso permanente'
}];
export function GuaranteeSection() {
  const [ref, isVisible] = useReveal();
  const [ref2, isVisible2] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-98">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-99">
        {/* Cómo recibo el material */}
        <div ref={ref} className={`reveal text-center ${isVisible ? 'is-visible' : ''}`} data-id="element-100">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-101">
            ♡ Cómo recibo el material ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-6" data-id="element-102">
            Acceso simple{' '}
            <span className="italic text-[#e89aaa]" data-id="element-103">y para siempre.</span>
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-104">
            {DELIVERY.map((d, i) => <div key={i} className="bg-white rounded-2xl p-4 border border-[#f4b6c2]/30 shadow-sm flex flex-col items-center gap-2" data-id="element-105">
                <span className="text-2xl" data-id="element-106">{d.emoji}</span>
                <span className="text-xs md:text-sm font-medium text-[#6b4f3a]" data-id="element-107">
                  {d.label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Garantía */}
        <div ref={ref2} className={`reveal bg-gradient-to-br from-[#fdf2f4] to-[#fce7e9]/60 rounded-[2.5rem] p-8 md:p-12 text-center border border-[#f4b6c2]/40 shadow-[0_15px_40px_rgba(232,154,170,0.08)] ${isVisible2 ? 'is-visible' : ''}`} data-id="element-108">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border border-[#f4b6c2]/40 mb-4 shadow-sm" data-id="element-109">
            <ShieldCheckIcon className="w-8 h-8 text-[#e89aaa]" data-id="element-110" />
          </div>

          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-111">
            ♡ Garantía ♡
          </span>

          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-4" data-id="element-112">
            Garantía de <span className="italic text-[#e89aaa]" data-id="element-113">7 días.</span>
          </h2>

          <p className="text-base md:text-lg text-[#8b6f47] leading-relaxed max-w-lg mx-auto" data-id="element-114">
            Probalo tranquila. Si el MegaPack no cumple tus expectativas, podés
            solicitar la devolución dentro de los primeros 7 días.
          </p>
        </div>
      </div>
    </section>;
}